<template>
	<multiselect 
		v-model="selectedRegion" 
		:id="keyId" 
		:label="label" 
		track-by="id" 
		:placeholder="placeholder" 
		:options="regions" 
		:multiple="false" />
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
	name: 'SelectOption',
	props: ['keyId', 'defaultId', 'placeholder', 'url', 'label'],
	components: {
		Multiselect
	},
	data() {
		return {
			selectedRegion: null,
			regions: []
		}
	},
	methods: {
		get(){
			let _ = this
			_.axios.get(_.url)
				.then(resp => {
					_.regions = resp.data.data.rows
				}).catch(err => {
					console.log(err.response)
				})
		},
		getDetail(id) {
	    	let _ = this
	    	if ( id ) {
				_.axios.get(_.url + '?id=' + id).then(resp => {
		      		_.selectedRegion = resp.data.data.rows
		      	}).catch(err => {
			      	console.log(err.response)
			    })
			}
	    }
	},
	watch: {
		selectedRegion: function(val) {
			if (val){
				this.$emit('setValue', val.id)
			}
		},
		defaultId: function(val) {
			if (val == ""){
				this.selectedRegion = null
			} else {
				this.getDetail(val)
			}
		}
	},
	mounted() {
		this.get()
	}
}
</script>